export function decodeIdToken(idToken) {
  try {
    const payload = JSON.parse(atob(idToken.split(".")[1]));
    return {
        ...payload,
        groups: payload["cognito:groups"] || [],
        username: payload["cognito:username"] || "",
        companyId: payload["custom:companyId"] || "",
        role: payload["custom:role"] || ""
    };
  } catch {
    return null;
  }
}